<template>
  <div class="modal-wrap">
    <el-dialog
      title="自定义渠道"
      :visible.sync="showChnlModal"
      width="1000px"
      :close-on-click-modal="false"
      @closed="emitChnl"
    >
      <el-button
        type="primary"
        style="margin-bottom: 12px"
        icon="el-icon-plus"
        @click="editData()"
        >新增渠道</el-button
      >
      <div class="table-wrap">
        <el-table
          :data="tableData"
          style="width: 100%"
          height="100%"
          v-loading="tableLoading"
        >
          <el-table-column label="序号" type="index" width="80px">
          </el-table-column>
          <el-table-column prop="channel" label="渠道名称"> </el-table-column>
          <el-table-column prop="chnlAbbreviation" label="渠道缩写">
          </el-table-column>
          <el-table-column prop="remark" label="渠道说明"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="editData(scope.row)"
                >编辑</el-button
              >
              <el-button type="text" @click="delData(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showChnlModal = false">取消</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="新增渠道"
      :visible.sync="showEditModal"
      width="450px"
      :close-on-click-modal="false"
      @closed="modalClosed"
    >
      <el-form
        :rules="rules"
        ref="chnlEditRef"
        :model="formData"
        label-width="90px"
      >
        <el-form-item label="渠道名称:" prop="channel">
          <el-input
            v-model="formData.channel"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道缩写:" prop="chnlAbbreviation">
          <el-input
            v-model="formData.chnlAbbreviation"
            maxlength="10"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="渠道说明:">
          <el-input
            type="textarea"
            placeholder="请输入内容"
            v-model="formData.remark"
            maxlength="20"
            show-word-limit
            resize="none"
            :rows="4"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditModal = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="saveLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getChnl, addChnl, modifyChnl, deleteChnl } from "@/api/popuManage.js";
export default {
  name: "ChnlModal",
  data() {
    return {
      showChnlModal: false,
      showEditModal: false,
      saveLoading: false,
      tableData: [],
      formData: {
        channel: "",
        chnlAbbreviation: "",
        remark: "",
      },
      rules: {
        channel: [{ required: true, message: "渠道名称必填", trigger: "blur" }],
        chnlAbbreviation: [
          { required: true, message: "渠道缩写必填", trigger: "blur" },
        ],
      },
      editId: null,
      tableLoading: false,
    };
  },
  methods: {
    showModal() {
      this.showChnlModal = true;
      this.searchChnlList();
    },
    searchChnlList() {
      this.tableLoading = true;
      getChnl().then((res) => {
        this.tableLoading = false;
        if (res.code === "0000") {
          this.tableData = res.data;
        }
      });
    },
    saveData() {
      this.$refs.chnlEditRef.validate((valid) => {
        if (valid) {
          this.saveLoading = true;
          let data = JSON.parse(JSON.stringify(this.formData));
          if (this.editId) {
            data.id = this.editId;
            modifyChnl(data).then((res) => {
              this.saveLoading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "渠道编辑成功",
                  type: "success",
                });
                this.showEditModal = false;
                this.searchChnlList();
              }
            });
          } else {
            addChnl(data).then((res) => {
              this.saveLoading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "渠道新增成功",
                  type: "success",
                });
                this.showEditModal = false;
                this.searchChnlList();
              }
            });
          }
        }
      });
    },
    editData(row) {
      if (row) {
        this.editId = row.id;
        this.formData.channel = row.channel;
        this.formData.chnlAbbreviation = row.chnlAbbreviation;
        this.formData.remark = row.remark;
      } else {
        this.editId = null;
        this.formData.channel = "";
        this.formData.chnlAbbreviation = "";
        this.formData.remark = "";
      }
      this.showEditModal = true;
    },
    delData(row) {
      this.$confirm("确定删除渠道“" + row.channel + "”?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let id = row.id;
          deleteChnl({ id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                message: "渠道删除成功",
                type: "success",
              });
              this.searchChnlList();
            }
          });
        })
        .catch(() => {});
    },
    modalClosed() {
      this.$refs.chnlEditRef.clearValidate();
    },
    //弹框关闭刷新外部渠道数据
    emitChnl() {
      this.$emit("modalClosed");
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  .table-wrap {
    height: 500px;
  }
  /deep/ .el-form-item {
    &.is-required {
      .el-form-item__label::before {
        content: "*";
        display: inline-block;
        color: red;
      }
    }
  }
}
</style>